import { Injectable } from "@angular/core";
import { DayTime, DayType, IAbsenceRecordYearWise, IEmployeeLeaveDetail, LeaveType } from "@signal/asp-data-commons";
import { DateTime } from 'luxon';

@Injectable({
  providedIn: 'root'
})
export class AddLeavesService {
  leaveDetailsYearWise = [];
  trainingList = [];
  dayOffList = [];
  weeklyLeaveList = [];
  biWeeklyLeaveList = [];
  monthlyLeaveList = [];
  recurrentLeaveList = [];
  currentDate = DateTime.now();
  dealerShipHoliday = [];
  exceptionalList = [];
  dateFormat = 'yyyy-MM-dd';

  constructor() { 
  }
  public getEmployeeLeaveDetails(data, minimumDate) {
    const employeeLeaveDetails = data.employee.employeeLeaveDetails
    this.leaveDetailsYearWise = [];
    this.trainingList = [];
    this.dayOffList = [];
    this.weeklyLeaveList = [];
    this.biWeeklyLeaveList = [];
    this.monthlyLeaveList = [];
    this.recurrentLeaveList = [];
    const minDate = DateTime.fromFormat(minimumDate, this.dateFormat);
    if (employeeLeaveDetails) {
      for (const employeeLeaves of employeeLeaveDetails) {
        const empLeaveDetails = employeeLeaves?.leaveDetails ?? [];
        const year = employeeLeaves.year;
        const leaveDetails = Object.assign([], empLeaveDetails);
        const employeeleave: IAbsenceRecordYearWise = { year: year, leaveDetails: leaveDetails };
        this.leaveDetailsYearWise.push(employeeleave);
        /* ---------  get recurrent leave list ------------*/
        if(year === -1) {
          this.recurrentLeaveList = [...empLeaveDetails];
        } else {
        /* --------  get leave list of training, day-off -------- */
          for (const leaveDetails of empLeaveDetails) {
            if (leaveDetails.leaveType === LeaveType.training &&
              DateTime.fromFormat(leaveDetails.leaveDate, this.dateFormat) >= minDate) {
              this.trainingList.push(leaveDetails);
            }
            if (leaveDetails.leaveType === LeaveType.dayoff &&
              DateTime.fromFormat(leaveDetails.leaveDate, this.dateFormat) >= minDate) {
              this.dayOffList.push(leaveDetails);
            }
          }
        }
       
      }
    }
  }
  public removeLeavesFromEmployeeDetails(employeeleaves,daySelected, dayTime, key?,leaveType?,endDate?) {
    
      return employeeleaves.leaveDetails = employeeleaves.leaveDetails.filter((day) => {//remove selected dates from employeeleaves
        if(( daySelected !== day.leaveDate) && (!day.isRecurrentLeave || key === 'series')) {
          if(leaveType?.includes('LY')){
            const leave = {leaveDate:daySelected,leaveType,endDate}
            const rec =this.checkDate(leave,day.leaveDate);
            if(rec && this.exceptionalList.find(leave=>leave.leaveDate === daySelected)===undefined){
              return;
            }
          }
          return day;
        }
        else if (day.dayType === DayType.half) {
          const matchingleavelist = employeeleaves.leaveDetails.filter((leave) => {
            return leave.leaveDate === day.leaveDate;
          })
          if(key === "ok" && matchingleavelist.length>0){
            return;
          }
          if (matchingleavelist.length === 0 || (matchingleavelist.find(leave => leave.dayTime !== dayTime) &&
            day.dayTime !== dayTime) && !day.isRecurrentLeave) {
            return day;
          }
        }
        else {
          return;
        }
      });
    
   
  }

  public addLeaveExceptionalList( daySelected,key,dayTime?,leaveType?,endDate?) {
    for (const employeeleaves of this.leaveDetailsYearWise) {
      if(employeeleaves.year === -1){
        employeeleaves.leaveDetails = employeeleaves.leaveDetails.map(leaveDetail => {
        const leaveList = leaveDetail.leaveType=== LeaveType.weekly? this.weeklyLeaveList : leaveDetail.leaveType=== LeaveType.biweekly ? this.biWeeklyLeaveList :
        leaveDetail.leaveType === LeaveType.monthly? this.monthlyLeaveList :[];

        const cloneLeaveDetail = Object.assign({}, leaveDetail)
        return this.updateExceptionalList(key,cloneLeaveDetail,daySelected,leaveType,dayTime,leaveList)
                    
        }).filter((item): item is IEmployeeLeaveDetail => !!item)
      }else{
        employeeleaves.leaveDetails = this.removeLeavesFromEmployeeDetails(employeeleaves,daySelected,dayTime,key,leaveType,endDate)
      }
    }
    
  }
  public resetValues(){
    this.trainingList = [];
    this.dayOffList = [];
    this.weeklyLeaveList = [];
    this.biWeeklyLeaveList = [];
    this.monthlyLeaveList = [];
    this.exceptionalList = [];
  }
  private checkDateInCurrentSeries(leaveDetail,daySelected):boolean{
    const leaveDateLuxon = DateTime.fromFormat(leaveDetail.leaveDate,this.dateFormat);
    const daySelectedLuxon = DateTime.fromFormat(daySelected,this.dateFormat);
   return (leaveDateLuxon.weekday === daySelectedLuxon.weekday )
  }
   private treatAsUTC(date):any {
    var result = new Date(date);
    result.setMinutes(result.getMinutes() - result.getTimezoneOffset());
    return result;
  }

  private daysBetween(startDate, endDate):any {
    var millisecondsPerDay = 24 * 60 * 60 * 1000;
    return Math.floor((this.treatAsUTC(endDate) - this.treatAsUTC(startDate)) / millisecondsPerDay);
}

public calculateLeave(date,leaveDetail){
  const isRecurrent = this.checkDate(leaveDetail,date)
  const leave = [...this.weeklyLeaveList,...this.biWeeklyLeaveList,...this.monthlyLeaveList].find(leave => leave.leaveDate === date );
  let exceptionDate ;
  /* ---------------  check date is exceptional  ----------------*/ 
    if(leaveDetail.exceptionalDates && leaveDetail.exceptionalDates.length > 0){
      leaveDetail.exceptionalDates.forEach(exceptionLeaveDetail=> {
        const isExceptionLeave = this.checkDate(exceptionLeaveDetail,date);
        if(isExceptionLeave){
          exceptionDate = date
        }
      })
    }
  
    if(isRecurrent && (leave===undefined ||  (JSON.stringify({...leave,leaveType:'',exceptionalDates:[]}) !== JSON.stringify({ ...leaveDetail, leaveDate:date,leaveType:'',exceptionalDates:[] }) &&
    (leave.dayType ===  leaveDetail.dayType && leave.dayTime !==  leaveDetail.dayTime )))&& exceptionDate === undefined){
      /* ---------------  push date in leave list ----------------*/ 
      switch(leaveDetail.leaveType){
        case LeaveType.weekly:{
          this.weeklyLeaveList.push(({ ...leaveDetail, leaveDate:date }));
          this.weeklyLeaveList = this.filterUniqueList(this.weeklyLeaveList)
          break;
        }
        case LeaveType.biweekly:{
          this.biWeeklyLeaveList.push(({ ...leaveDetail, leaveDate:date }))
          this.biWeeklyLeaveList = this.filterUniqueList(this.biWeeklyLeaveList)
          break;
        }
        case LeaveType.monthly:{
          this.monthlyLeaveList.push(({ ...leaveDetail, leaveDate:date }))
          this.monthlyLeaveList = this.filterUniqueList(this.monthlyLeaveList)
          break;
        }
      }
    }
  }
  
  updateExceptionalList(key,cloneLeaveDetail,daySelected,leaveType,dayTime,leaveList){
    switch(key){
      case "save":{
        if((leaveType.includes('LY')) && 
        ((dayTime === DayTime.NA && cloneLeaveDetail.leaveType === leaveType) || 
        (cloneLeaveDetail.dayTime !== dayTime && cloneLeaveDetail.dayTime !== DayTime.NA && dayTime === DayTime.NA)) && cloneLeaveDetail.leaveDate === daySelected){
          return ;
        }
        else if(((leaveType.includes('LY')))){
          return cloneLeaveDetail;
        }
        else{
          if((cloneLeaveDetail.dayType !== DayType.half || (dayTime === "NA" || (dayTime !== "NA" && cloneLeaveDetail.dayTime=== dayTime) )) && ((cloneLeaveDetail.endDate && new Date(cloneLeaveDetail.leaveDate) <= new Date(daySelected) && new Date(daySelected)<= new Date(cloneLeaveDetail.endDate))||
          ((cloneLeaveDetail.endDate === ''|| cloneLeaveDetail.endDate === null) && new Date(cloneLeaveDetail.leaveDate).getDay() === new Date(daySelected).getDay()))){
            const data: IEmployeeLeaveDetail = {
              leaveDate: daySelected,
              leaveType: leaveType,
              dayType: dayTime === DayTime.NA ?DayType.full:DayType.half,
              dayTime: dayTime,
              isRecurrentLeave :false
            };
            const exceptionalDates = cloneLeaveDetail.exceptionalDates ?? [];
            return { ...cloneLeaveDetail, exceptionalDates: [...exceptionalDates, data] }
          }
            return cloneLeaveDetail;
        }
      }
      case "ok":{
        return cloneLeaveDetail
      }
      case "occurence":{
        if((cloneLeaveDetail.endDate && new Date(cloneLeaveDetail.leaveDate) <= new Date(daySelected) && new Date(daySelected)<= new Date(cloneLeaveDetail.endDate))||
        ((cloneLeaveDetail.endDate === ''|| cloneLeaveDetail.endDate === null) && new Date(cloneLeaveDetail.leaveDate).getDay() === new Date(daySelected).getDay())){
          const exceptionalDates = cloneLeaveDetail.exceptionalDates ?? [];
          return { ...cloneLeaveDetail, exceptionalDates: [...exceptionalDates, {...cloneLeaveDetail,leaveDate:daySelected,endDate:daySelected}] }
        }
        else{
          return cloneLeaveDetail
        }
      }
      case "series":{
        this.exceptionalList.forEach(exception=>{
          if(new Date(exception.leaveDate).getDay === new Date(cloneLeaveDetail.leaveDate).getDay && 
          new Date(exception.leaveDate)>= new Date(cloneLeaveDetail.leaveDate) && exception.leaveType !== cloneLeaveDetail.leaveType){
            const exceptionalDates = cloneLeaveDetail.exceptionalDates ?? [];
            cloneLeaveDetail = {...cloneLeaveDetail,exceptionalDates:[...exceptionalDates,exception]};
          }
        });
        if(cloneLeaveDetail.leaveDate !== daySelected && [...this.weeklyLeaveList,...this.biWeeklyLeaveList,...this.monthlyLeaveList].find(leave=> leave.leaveDate === daySelected )?.leaveType === cloneLeaveDetail.leaveType && this.checkDateInCurrentSeries(cloneLeaveDetail,daySelected)){
          const endDate = DateTime.fromFormat(daySelected, this.dateFormat).minus({ days: 1 }).toFormat(this.dateFormat)
          if(new Date(endDate) >= new Date(cloneLeaveDetail.leaveDate)  ){
            return { ...cloneLeaveDetail, endDate}
          }
          return ;
        }
        if(cloneLeaveDetail.leaveDate === daySelected ){
          return ;
        }
        return cloneLeaveDetail;
      }
      default:
        break;
      }
  }
  filterUniqueList(array){
    return array.filter((thing, index) => {
      delete thing.exceptionalDates;
      const _thing = JSON.stringify(thing);
      return index === array.findIndex(obj => {
        delete obj.exceptionalDates;
        return JSON.stringify(obj) === _thing;
      });
    });
  }
  private checkDate(leaveDetail,date){
    const numberOfDays =leaveDetail.leaveType === LeaveType.weekly? 7 : leaveDetail.leaveType === LeaveType.biweekly ? 14:
    leaveDetail.leaveType === LeaveType.monthly? 28 : 0 
    const demarcationdate = new Date(leaveDetail.leaveDate),
    today = new Date(date),
    days = this.daysBetween(demarcationdate,today),
    isRecurrent = days%numberOfDays==0;
    return (isRecurrent || (days===0 && numberOfDays===0)) && Math.sign(days)!== -1 && (leaveDetail.endDate === undefined || leaveDetail.endDate === ''||leaveDetail.endDate === null || today <=new Date(leaveDetail.endDate) ) ;
  }
}
